module.exports = __webpack_public_path__ + "static/media/napd.bd1731b7.png";